 export const initOpenReplay = async (uid: string, imid: string) => {
	console.log('initOpenReplay', uid, imid);
	if (!process.env.NEXT_PUBLIC_OPENREPLAY_PROJECT_KEY) {
		return;
	}

	const { tracker } = await import("@openreplay/tracker");
	const projectKey = process.env.NEXT_PUBLIC_OPENREPLAY_PROJECT_KEY
	const ingestPoint = process.env.NEXT_PUBLIC_OPENREPLAY_INGEST_POINT

	if (projectKey) {
		tracker.configure({
			projectKey,
			ingestPoint: ingestPoint,
			__DISABLE_SECURE_MODE: process.env.NODE_ENV !== 'production', // disable secure mode in development
		})
	}
	
 	if (typeof window !== 'undefined' && projectKey) {
      if (!tracker.isActive()) {
        try {
			await tracker.start({
				userID: uid,
				forceNew: false,
			} as any)
			
			tracker.setMetadata('uid', uid);
			tracker.setMetadata('imid', imid);
        } catch (error) {
          console.error("Failed to start OpenReplay tracker:", error)
        }
      }
    } else {
      console.warn("OpenReplay configuration missing: projectKey not found")
    }
}